<h1 mat-dialog-title style="margin-bottom: 1rem;">Profil bearbeiten</h1>
<mat-dialog-content>
  <form (keyup.enter)="save()" tabindex="0" [formGroup]="profileData">

    Bitte geben Sie Ihre neuen Daten ein. <br><br>

    <div class="form-field-wrapper">
      <div class="form-field-line-half">
        <mat-form-field #name appearance="outline">
          <mat-label>Vorname</mat-label>
          <input formControlName="firstName" id="input1" matInput placeholder="" type="text">
          @if (submitted && profileData.controls.firstName.hasError('maxlength')) {
            <mat-hint
              class="warning">
              Nur 255 Zeichen erlaubt
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Nachname</mat-label>
          <input formControlName="lastName" matInput placeholder="" type="text">
          @if (submitted && profileData.controls.lastName.hasError('maxlength')) {
            <mat-hint
              class="warning">
              Nur 255 Zeichen erlaubt
            </mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="form-field-line-third">
        <mat-form-field appearance="outline">
          <mat-label>Land</mat-label>
          <input formControlName="country" matInput placeholder="" type="text">
          @if (submitted && profileData.controls.country.hasError('maxlength')) {
            <mat-hint
              class="warning">
              Nur 255 Zeichen erlaubt
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Stadt</mat-label>
          <input formControlName="city" matInput placeholder="" type="text">
          @if (submitted && profileData.controls.city.hasError('maxlength')) {
            <mat-hint
              class="warning">
              Nur 255 Zeichen erlaubt
            </mat-hint>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>PLZ</mat-label>
          <input formControlName="zip" matInput placeholder="" type="number" max="999999">
          @if (submitted && profileData.controls.zip.hasError('zipCodeTooBig')) {
            <mat-hint
              class="warning">
              Nur 6 Zeichen erlaubt
            </mat-hint>
          }
        </mat-form-field>
      </div>
      <mat-form-field class="w100" appearance="outline">
        <mat-label>Straße</mat-label>
        <input formControlName="street" matInput placeholder="" type="text">
        @if (submitted && profileData.controls.street.hasError('maxlength')) {
          <mat-hint
            class="warning">
            Nur 255 Zeichen erlaubt
          </mat-hint>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-buttons">
  <button (click)="cancel()" mat-raised-button>Zurück</button>
  <button (click)="save()" color="primary" mat-raised-button>Profil speichern</button>
</mat-dialog-actions>
